import { render, staticRenderFns } from "./LastSeasonYieldNoticePrompt.vue?vue&type=template&id=40a9502a&scoped=true"
import script from "./LastSeasonYieldNoticePrompt.vue?vue&type=script&lang=ts"
export * from "./LastSeasonYieldNoticePrompt.vue?vue&type=script&lang=ts"
import style0 from "./LastSeasonYieldNoticePrompt.vue?vue&type=style&index=0&id=40a9502a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9502a",
  null
  
)

export default component.exports